import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=31196aa1"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31196aa1')) {
      api.createRecord('31196aa1', component.options)
    } else {
      api.reload('31196aa1', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=31196aa1", function () {
      api.rerender('31196aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/Link.vue"
export default component.exports